import type { Plugin } from 'vue'
import Buttons from '@el-plus/components/buttons'
import Form from '@el-plus/components/form'
import Input from '@el-plus/components/input'
import SearchListPage from '@el-plus/components/search-list-page'
import Select from '@el-plus/components/select'
import Table from '@el-plus/components/table'
import Title from '@el-plus/components/title'
import Header from '@el-plus/components/header'
import DatePickerRange from '@el-plus/components/date-picker-range'
import CustomColumn from '@el-plus/components/custom-column'
import Link from '@el-plus/components/link'
import Attachment from '@el-plus/components/attachment'
import UniVue from '@el-plus/components/uni-vue'
import FooterInfo from '@el-plus/components/footer-info'

export default [
  Buttons,
  Form,
  Input,
  SearchListPage,
  Select,
  Table,
  Title,
  Header,
  DatePickerRange,
  CustomColumn,
  Link,
  Attachment,
  UniVue,
  FooterInfo,
] as Plugin[]
